import { render } from "./ColourForm.vue?vue&type=template&id=6379b842"
import script from "./ColourForm.vue?vue&type=script&lang=js"
export * from "./ColourForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__